import { render, staticRenderFns } from "./AppCode.vue?vue&type=template&id=5ac8b550&scoped=true&"
import script from "./AppCode.vue?vue&type=script&lang=js&"
export * from "./AppCode.vue?vue&type=script&lang=js&"
import style0 from "./AppCode.vue?vue&type=style&index=0&id=5ac8b550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac8b550",
  null
  
)

export default component.exports